import icHeartEmpty from '../../assets/img/ic-heart-empty.svg';
import icHeartFull from '../../assets/img/ic-heart-full.svg';

const formatLanguages = (languages) => {
    if (!Array.isArray(languages)) return 'n/a';

    const languageNames = languages
        .map((language) => String(language || '').trim())
        .filter(Boolean);

    return languageNames.length > 0 ? languageNames.join(', ') : 'n/a';
};

const formatPopulation = (value) => {
    if (value === null || value === undefined || value === '') return 'n/a';

    const population = Number(value);
    return Number.isFinite(population) && population >= 0
        ? population.toLocaleString()
        : 'n/a';
};

const MobileDiscoveryCityCard = ({
    city,
    isFavorite = false,
    onFavoriteToggle,
    onOpenCity,
    secondStat,
}) => {
    const cityName = city.cityName || city.name || 'n/a';
    const countryName = city.countryName || city.country?.name || city.country || 'n/a';
    const cityId = city.id || city.cityId || 'n/a';
    const languages = formatLanguages(city.languagesSpoken);
    const secondStatLabel = secondStat?.label || 'Population';
    const secondStatValue = secondStat
        ? secondStat.value
        : formatPopulation(city.regionCitizensNumber);
    const isSecondStatUnavailable = secondStatValue === null
        || secondStatValue === undefined
        || secondStatValue === ''
        || secondStatValue === 'n/a';

    const handleOpenCity = () => {
        if (onOpenCity) onOpenCity(city);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpenCity();
        }
    };

    const handleFavoriteClick = (event) => {
        event.stopPropagation();
        if (onFavoriteToggle) onFavoriteToggle(city._id);
    };

    return (
        <article
            className="mobile-company-card mobile-city-card"
            role="button"
            tabIndex={0}
            onClick={handleOpenCity}
            onKeyDown={handleKeyDown}
        >
            <div className="mobile-company-card__body">
                <div className="mobile-company-card__top mobile-city-card__top">
                    <div className="mobile-company-card__identity">
                        <div className="mobile-company-card__meta">
                            <h3 className="mobile-company-card__title mb-0">{cityName}</h3>
                            <p className="mobile-city-card__country">{countryName}</p>
                            <p className="mobile-city-card__languages" title={languages}>
                                {languages}
                            </p>
                        </div>
                    </div>

                    <div className="mobile-company-card__actions mobile-company-card__actions--favorite-only">
                        <button
                            className={`mobile-company-card__favorite${isFavorite ? ' is-active' : ''}`}
                            type="button"
                            aria-label={isFavorite ? `Remove ${cityName} from favorites` : `Add ${cityName} to favorites`}
                            aria-pressed={isFavorite}
                            onClick={handleFavoriteClick}
                            onKeyDown={(event) => event.stopPropagation()}
                        >
                            <img
                                src={isFavorite ? icHeartFull : icHeartEmpty}
                                alt=""
                                aria-hidden="true"
                            />
                        </button>
                    </div>
                </div>
            </div>

            <div
                className="mobile-company-card__stats-strip mobile-company-card__stats-strip--two"
                aria-label="City details"
            >
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">ID</span>
                    <span className={`mobile-company-card__stat-value${cityId === 'n/a' ? ' is-muted' : ''}`}>
                        {cityId}
                    </span>
                </div>
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">{secondStatLabel}</span>
                    <span className={`mobile-company-card__stat-value${isSecondStatUnavailable ? ' is-muted' : ''}`}>
                        {isSecondStatUnavailable ? 'n/a' : secondStatValue}
                    </span>
                </div>
            </div>
        </article>
    );
};

export default MobileDiscoveryCityCard;
